module.exports = {
  // 系统名称
  name: "吉吉收",
  // 必填: 后端api地址, 参照下面格式
	apiUrl: "https://huishou.mmkj123.com",
  founUrl:"https://huishou.mmkj123.com/",
  baseUrl:"https://huishou.mmkj123.com",
  // 上传图片url
  uploadUrl:"/api/upload/image",
  addWx:'/pages/my/setup',
  wxapp_id:"10026",
  province:'黑龙江',
  postType:10
}



// WEBPACK FOOTER //
// ./src/config.js